var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cly-vue-tabs"},[_c('el-tabs',_vm._g(_vm._b({attrs:{"type":"button"},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)},'el-tabs',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }